import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import { initialSelectedNumeriNeri } from "./helper";

const initialState = {
  numeriNeri: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  createNumeriNeri: {
    data: {
      tdrList: [],
      odrList: [],
      isNngPlus: '',
    },
    loading: false,
  },
  selectedNumeriNeri: initialSelectedNumeriNeri,
  createNumeriNeriLoading: false,
  exportNumeriNeriLoading: false,
};

const setNumeriNeriData = (state, action) => {
  return updateObject(state, {
    numeriNeri: updateObject(state.numeriNeri, {
      [action.key]: action.value,
    }),
  });
};

const setCreateNumeriNeriData = (state, action) => {
  return updateObject(state, {
    createNumeriNeri: updateObject(state.createNumeriNeri, {
      [action.key]: action.value,
    }),
  });
};

const setCreateNumeriNeriLoading = (state, action) => {
  return updateObject(state, {
    createNumeriNeriLoading: action.value,
  });
};

const setCurrentNumeriNeri = (state, action) => {
  return updateObject(state, {
    selectedNumeriNeri: updateObject(state.selectedNumeriNeri, {
      [action.key]: action.value,
    }),
  });
};

const setExportNumeriNeriLoading = (state, action) => {
  return updateObject(state, {
    exportNumeriNeriLoading: action.value,
  });
};

const numeriNeriReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_GESTIONI_NUMERI_NERI_DATA_AND_LOADING:
      return setNumeriNeriData(state, action);
    case actionTypes.CREATE_NUMERI_NERI_DATA:
      return setCreateNumeriNeriData(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_NUMERI_NERI:
      return setCreateNumeriNeriLoading(state, action);
    case actionTypes.GET_CURRENT_NUMERI_NERI:
      return setCurrentNumeriNeri(state, action);
    case actionTypes.EXPORT_NUMERI_NERI_LOADING:
      return setExportNumeriNeriLoading(state, action);
    default:
      return state;
  }
};

export default numeriNeriReducer;
